export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "step": {
          "decision": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Décision"])},
          "handling_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prise en charge"])}
        }
      },
      "en": {
        "step": {
          "decision": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Decision"])},
          "handling_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Handling type"])}
        }
      }
    }
  })
}
